import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { industries } from '../data/mock';
import { Factory, Sprout, HardHat, Fuel, FlaskConical, Droplets } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const iconMap = {
  Factory: Factory,
  Sprout: Sprout,
  HardHat: HardHat,
  Fuel: Fuel,
  FlaskConical: FlaskConical,
  Droplets: Droplets
};

export const IndustriesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Page Header */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-slate-50 via-orange-50/30 to-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center space-y-4">
            <h1 className="text-4xl lg:text-6xl font-bold text-slate-900">
              Industries We Serve
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Trusted solutions across diverse industrial sectors worldwide
            </p>
          </div>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry) => {
              const IconComponent = iconMap[industry.icon];
              return (
                <Card
                  key={industry.id}
                  className="group hover:shadow-xl transition-all duration-300 border-slate-200 hover:border-orange-300 bg-white"
                >
                  <CardContent className="p-8 space-y-4">
                    <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center group-hover:bg-[#D8461D] transition-colors duration-300">
                      <IconComponent size={32} className="text-[#D8461D] group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 group-hover:text-[#D8461D] transition-colors">
                      {industry.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {industry.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Industry Applications */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center space-y-8">
            <h2 className="text-3xl lg:text-4xl font-bold text-slate-900">
              Versatile Applications
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed">
              Our industrial hoses and pipes are engineered to meet the demanding requirements of various 
              sectors. From high-pressure applications in oil & gas to precise fluid management in chemical 
              processing, our products deliver reliable performance in the toughest conditions.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              With over 10 years of experience and ISO certification, we understand the unique challenges 
              each industry faces. Our solutions are designed to ensure safety, efficiency, and durability 
              across all applications.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-r from-[#D8461D] to-orange-600 rounded-2xl p-8 md:p-12 text-center space-y-6">
            <h3 className="text-3xl lg:text-4xl font-bold text-white">
              Can't Find Your Industry?
            </h3>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              We work with diverse sectors and can create custom solutions for your specific needs
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-white text-[#D8461D] hover:bg-slate-100 px-8 py-6 text-lg font-semibold">
                Contact Our Team
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IndustriesPage;
